import { render, staticRenderFns } from "./PaymentServices.vue?vue&type=template&id=1d4f91ea&"
import script from "./PaymentServices.vue?vue&type=script&lang=js&"
export * from "./PaymentServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports